import React from "react";
import Card from "./Card";

const PosCards = () => {
  return (
    <section className="bg-gray-100 border-t py-8" id="pos">
      <div className="container mx-auto flex flex-wrap pt-4 pb-12">
        <h3 className="w-full my-2 text-3xl font-bold leading-tight text-center text-gray-800">
          Partner Registrierkassen
        </h3>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="Matrix POS"
            link="https://www.42-gmbh.de/"
            imgSrc={require("./../images/pos/42.png")}
            text="IT - Komplettlösungen"
            justifyItems="between"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="MELZER X3000"
            link="https://www.melzer-kassen.com/"
            imgSrc={require("./../images/pos/melzer.svg")}
            text="Das Kassensystem mit Touch"
            justifyItems="between"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="GKS"
            link="https://www.ederedv.at/"
            imgSrc={require("./../images/pos/gks.png")}
            text="Alles aus einer Hand"
            justifyItems="between"
          />
        </div>

        <div className="w-full md:w-1/2 lg:w-1/4 p-6 flex flex-col flex-grow flex-shrink">
          <Card
            title="octobox"
            link="https://www.octobox.net/"
            imgSrc={require("./../images/pos/octobox.png")}
            text="Smart POS System"
            justifyItems="between"
          />
        </div>
      </div>
    </section>
  );
};

export default PosCards;
